export const COACH = 'coach';
export const BUSINESS_COACH = 'businessCoach';
export const BUSINESS_LEADER = 'businessLeader';

export const RAW_COACH = 'coach';
export const RAW_BUSINESS_COACH = 'business_coach';
export const RAW_BUSINESS_LEADER = 'business_leader';
